const SOMETHING_WENT_WRONG = 'Something went wrong';

export { SOMETHING_WENT_WRONG };
